module.exports = __webpack_public_path__ + "static/media/airbus.c851bf19.svg";